module.exports = __webpack_public_path__ + "static/img/Gold4.63628b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Gold4.svg
// module id = CJGN
// module chunks = 35